exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-container .chart div{overflow-x:scroll}.chart-container .chart div::-webkit-scrollbar{display:none}", ""]);

// exports
